var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`m-3 p-2 wrapper wrapper--border wrapper--default`},[_c('h2',{staticClass:"text-center"},[_vm._v("Openstaande bedragen - "+_vm._s(_vm.display_name))]),(_vm.loading)?_c('Loading'):_vm._e(),_c('OpenAmountsTable',{attrs:{"table_data":_vm.open_amounts_per_person}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }